// extracted by mini-css-extract-plugin
export default {"container":"Common_container__+bJZ5"};